var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trigger-waiting-for-event display-flex flex-column width-100 height-100 flex-centerize"},[_c('MessageBox',{attrs:{"title":_vm.title,"maxWidth":"350px"}},[_vm._t("content")],2),_c('div',{staticClass:"outter-content mt-7 text-align-center"},[_vm._t("bottom")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }